import React from 'react'

const PodcastPlayer = ({ story }) => {
  return (
    <>
      <div className='podcastPlayer'>
        <iframe title={story.title} src={`${story.post_type_meta.podcast.iframe_src}?site=roughnrowdybrawl`} />
      </div>
      <style jsx>{`
        .podcastPlayer {
          margin-bottom: 25px;
        }
        .podcastPlayer iframe {
          min-height: 200px;
          width: 100%;
        }
      `}</style>
    </>
  )
}

export default PodcastPlayer
